export const SUPPORT_EMAIL = 'info@mapavyuky.cz';

/**
 * Closing sentence for a message about a failure the user cannot fix themselves — an unexplained
 * API error, a page that will not load, data that will not display. A message the user can act on
 * (validation, a lock, a missing license) does not carry it.
 */
export const SUPPORT_HINT = `Pokud problém přetrvává, kontaktujte nás prosím na ${SUPPORT_EMAIL}.`;
